// extracted by mini-css-extract-plugin
export default {"block":"pe","flex":"qe","radio":"re","label":"se","error":"te","extra":"ue"};